import React from 'react';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getDeviationResourceType, getDeviationUrl } from '../../../_helpers';
var CommentControl = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation, hasCommentedOn = _a.hasCommentedOn, showStatNumbers = _a.showStatNumbers, className = _a.className;
    var showStats = useOverlayContext(deviation).showStats;
    return (React.createElement(ThumbIconButton, { className: className, type: "comment", isEngaged: hasCommentedOn, showStatValue: showStats && showStatNumbers, statValue: (_b = deviation.stats) === null || _b === void 0 ? void 0 : _b.comments, href: "".concat(getDeviationUrl(deviation), "#comments"), biData: BiData({
            evid: 105,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            creatorid: (_d = (_c = deviation.author) === null || _c === void 0 ? void 0 : _c.useridUuid) !== null && _d !== void 0 ? _d : '',
            sectionname: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
        }) }));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map